module.exports = __webpack_public_path__ + "static/media/Icon-3.2cfe9dfe.svg";